// src/components/Programacion/utils.js
export function getSectorNameByValvulaId(valvulaId, sectores) {
  for (const sector of sectores) {
    if (sector.valvulas.some((v) => String(v.valvulaId) === String(valvulaId))) {
      return sector.sectorNombre;
    }
  }
  return "-";
}

export function construirValvulasConDuracion(sectoresSeleccionados, duracionComun) {
  if (duracionComun.trim()) {
    const unique = [];
    const seen = new Set();
    sectoresSeleccionados.forEach((sec) =>
      sec.valves.forEach((v) => {
        if (!seen.has(v.valvulaId)) {
          seen.add(v.valvulaId);
          unique.push({ valvulaId: v.valvulaId, duration: duracionComun.trim() });
        }
      })
    );
    return unique;
  }
  // sino, cada sector su propio duration
  return sectoresSeleccionados.flatMap((sec) =>
    sec.valves.map((v) => ({
      valvulaId: v.valvulaId,
      duration: sec.duracionComunSector.trim() || "",
    }))
  );
}
